(function () {
  var REF_ATTRS = ['aria-labelledby', 'aria-describedby'];

  function hideDecorativeSvgs(root) {
    var svgs = root.querySelectorAll ? root.querySelectorAll('svg:not([aria-hidden])') : [];
    if (root.tagName && root.tagName.toLowerCase() === 'svg' && !root.hasAttribute('aria-hidden')) svgs = [root].concat([].slice.call(svgs));
    [].forEach.call(svgs, function (svg) {
      if (
        svg.getAttribute('role') === 'img' ||
        svg.hasAttribute('aria-label') ||
        svg.hasAttribute('aria-labelledby') ||
        svg.querySelector('title')
      ) return;
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
  }

  function trimIds(root) {
    var els = root.querySelectorAll ? root.querySelectorAll('[id]') : [];
    [].forEach.call(els, function (el) {
      var trimmed = el.id.trim();
      if (trimmed !== el.id && !document.getElementById(trimmed)) el.id = trimmed;
    });
  }

  function pruneBrokenRefs(root) {
    REF_ATTRS.forEach(function (attr) {
      var els = root.querySelectorAll ? root.querySelectorAll('[' + attr + ']') : [];
      if (root.hasAttribute && root.hasAttribute(attr)) els = [root].concat([].slice.call(els));
      [].forEach.call(els, function (el) {
        var ids = el.getAttribute(attr).split(/\s+/).filter(Boolean);
        // Only card badges are optional; leave every other reference alone
        var valid = ids.filter(function (id) { return !/Badge-/.test(id) || document.getElementById(id); });
        if (valid.length === ids.length) return;
        if (valid.length) el.setAttribute(attr, valid.join(' '));
        else el.removeAttribute(attr);
      });
    });
  }

  function run(root) {
    hideDecorativeSvgs(root);
    trimIds(root);
    pruneBrokenRefs(root);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (node) {
        if (node.nodeType === 1) run(node);
      });
    });
    // Refs can point outside the inserted subtree, so re-check the whole document
    pruneBrokenRefs(document);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }
})();
